<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">チャージ項目検索</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="search" class="btn-search" v-permit.SHARP_CI_SEARCH>{{
          $t('app.buttons.search')
        }}</v-btn>
        <v-btn to="/m0221/new" v-if="false" v-permit.SHARP_CI_NEW>{{
          $t('app.buttons.new')
        }}</v-btn>
        <v-btn
          :disabled="selected.length !== 1"
          @click="edit"
          v-permit.SHARP_CI_EDIT.SHARP_CI_DETAIL
          >{{ $t('app.buttons.edit') }}</v-btn
        >
        <v-btn
          :disabled="selected.length === 0"
          @click="remove"
          v-if="false"
          v-permit.SHARP_CI_DELETE
          >{{ $t('app.buttons.remove') }}</v-btn
        >

        <v-btn
          @click="exportCsv"
          class="mr-2"
          small
          v-permit.SHARP_CI_DOWNLOAD
          >{{ $t('app.buttons.csvExport') }}</v-btn
        >
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs6>
              <remote-autocomplete
                :label="$t('app.labels.incoterm')"
                item-text="code"
                url="incoterms/kv"
                v-model="query.incotermId"
              />
            </v-flex>
            <v-flex md3 sm6 xs6>
              <v-text-field
                clearable
                label="チャージ項目"
                v-model="query.name"
              />
            </v-flex>
            <v-flex md3 sm6 xs6>
              <remote-select
                label="チャージ区分"
                url="charge-item-type/kv"
                v-model="query.typeId"
              />
            </v-flex>
            <v-flex md3 sm6 xs6>
              <remote-select
                label="運送形態"
                url="transport-modes/kv"
                v-model="query.transportModeId"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        class="elevation-0"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.code }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.typeName }}</td>
          <td>{{ props.item.screenStatistics }}</td>
          <td>{{ lookupNames(props.item.recordUnits) }}</td>
          <td>{{ lookupCodes(props.item.incoterms) }}</td>
          <td>{{ props.item.taxTypeName }}</td>
          <td>{{ props.item.subTypeName }}</td>
          <td>{{ props.item.transportModeName }}</td>
          <td>{{ props.item.arCode }}</td>
          <td>{{ props.item.apCode }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      selected: [],
      results: [],
      loading: false,
      pagination: {
        page: 1,
      },
      headers: [
        { text: 'チャージCD', value: 'code', sortable: false },
        { text: 'チャージ項目', value: 'name', sortable: false },
        { text: 'チャージ区分', value: 'type.name', sortable: false },
        {
          text: '統計項目',
          value: 'chargeItemScreenStatistics',
          sortable: false,
        },
        { text: '課金単位', value: 'chargeUnitName', sortable: false },
        { text: '建値', value: 'incotermName', sortable: false },
        { text: '税区分', value: 'consumptionTaxName', sortable: false },
        { text: '諸掛区分', value: 'subType.name', sortable: false },
        { text: '輸送形態', value: 'transportMode.code', sortable: false },
        { text: '売上勘定', value: 'arCode', sortable: false },
        { text: '買掛勘定', value: 'apCode', sortable: false },
      ],
      query: {},
    }
  },
  methods: {
    exportCsv() {
      this.$http
        .get('charge-items', {
          params: {
            ...this.query,
            page: 0,
            size: 999999,
            sort: [
              this.pagination.sortBy,
              this.pagination.descending ? 'desc' : 'asc',
            ].join(','),
          },
        })
        .then((res) => {
          let headers = [
            'code',
            'name',
            'typeName',
            'subTypeName',
            'transportModeName',
            'arCode',
            'apCode',
          ]
          let showHeaders = [
            this.$t('チャージCD'),
            this.$t('チャージ項目'),
            this.$t('チャージ区分'),
            this.$t('諸掛区分'),
            this.$t('輸送形態'),
            this.$t('売上勘定'),
            this.$t('買掛勘定'),
          ]
          let data = res.data.content
          console.log(data)
          this.$exportTable(data, headers, showHeaders, 'チャージ項目')
        })
    },
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
        },
      }
    },
    search() {
      this.pagination.page = 1
      this.load()
    },
    load() {
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.$http.get('/charge-items', this.params()).then((res) => {
        this.pagination.page = res.data.number + 1
        this.pagination.rowsPerPage = res.data.size
        this.pagination.totalItems = res.data.totalElements
        this.results = res.data.content
        this.loading = false
        this.selected = []
      })
    },
    edit() {
      this.$router.push({
        name: 'EditM0221',
        query: { id: this.selected[0].id },
      })
    },
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          Promise.all(
            this.selected.map((s) => {
              return this.$http.delete(`/charge-items/${s.id}`)
            })
          ).then(() => {
            this.load()
            this.selected = []
          })
        }
      )
    },
    lookupNames(lookups) {
      if (lookups.length > 0) {
        return lookups
          .map((lookup) => lookup.ja_JP)
          .reduce((x, y) => x + ', ' + y)
      } else {
        return ''
      }
    },
    lookupCodes(lookups) {
      if (lookups.length > 0) {
        return lookups
          .map((lookup) => lookup.code)
          .reduce((x, y) => x + ', ' + y)
      } else {
        return ''
      }
    },
  },
  mounted() {
    this.$loadParams()
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
  },
}
</script>
